import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  inputArray: '',
  groupByFields: {
    values: [],
  },
  aggregations: {
    values: [],
  },
  outputFormat: 'array',
  includeCount: true,
  skipEmptyGroups: true,
};

export default defaults;
